import React from 'react'
import PropTypes from 'prop-types'
import {
  Heading as TRHeading,
  Text as TRText,
  Box,
} from '@planningcenter/tapestry-react'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism'
import ReactMarkdown from 'react-markdown'
import Heading from "./typography/heading"
import Link from "./typography/link"

export const PageHeading = props => {
  return <TRHeading color="primary" weight={600} {...props} />
}

export { Heading }

export const Text = props => {
  return <TRText lineHeight={3} {...props} />
}

export { Link }

export const Code = props => {
  return (
    <TRText
      inline
      as="code"
      fontFamily="'Inconsolata',monospace"
      lineHeight={2.5}
      backgroundColor="grey-3"
      paddingHorizontal={0.8}
      radius={4}
      style={{ wordBreak: 'break-all' }}
      {...props}
    />
  )
}

export const CodeBlock = props => {
  return (
    <Box>
      <SyntaxHighlighter style={atomDark} {...props} />
    </Box>
  )
}

export const ListItem = props => {
  return <TRText as="li" display="list-item" marginBottom={2} {...props} />
}

export const List = ({ ordered = false, ...restProps }) => {
  return <TRText as={ordered ? 'ol' : 'ul'} paddingLeft={4} {...restProps} />
}

List.propTypes = { ordered: PropTypes.bool }
List.Item = ListItem

export const Markdown = props => {
  const components = {
    p: Text,
    em: ({ children }) => (
      <Text inline italic>
        {children}
      </Text>
    ),
    strong: ({ children }) => (
      <Text inline weight={600}>
        {children}
      </Text>
    ),
    code: ({ inline, children, className = 'language-json' }) => {
      return inline ? (
        <Code>{children}</Code>
      ) : (
        <CodeBlock language={className.replace('language-', '')}>
          {children}
        </CodeBlock>
      )
    },
    ol: ({ children }) => <List ordered>{children}</List>,
    ul: List,
    li: List.Item,
  }

  return <ReactMarkdown components={components} {...props} />
}
